import React from 'react';
import { Row, Col } from 'react-bootstrap';
import ResourceDetails from '../../components/ResourceDetails';

export default function AccountDetails(props) {
  const { account } = props;

  return (
    <>
      <Row style={{ marginBottom: '2em' }}>
        <Col md={2}>
          <ResourceDetails
            header={'Organization'}
            value={account.organization.name}
            variant={'link'}
            link_route={`/organizations/${account.organization.id}`}
          />
        </Col>
        <Col md={2}>
          <ResourceDetails
            header={'Reference ID'}
            value={account.reference_id}
          />
        </Col>
        <Col md={2}>
          <ResourceDetails
            header={'Utility Provider'}
            value={account.utility_provider}
          />
        </Col>
        <Col md={2}>
          <ResourceDetails
            header={'Unit of Measure'}
            value={account.default_consumption_unit}
          />
        </Col>
        <Col md={2}>
          <ResourceDetails
            header={'Building(s)'}
            value={account.buildings.length}
          />
        </Col>
      </Row>
    </>
  );
}
